export enum EventName {
  JAVASCRIPT_START = 'javascript_start',
  MARKETING_TILE_IMAGE_LOADED = 'marketing_tile_image_loaded',
  MAIN_HERO_IMAGE_LOADED = 'main_hero_image_loaded',
  REACT_START = 'react_start',
}
